/* log2x self-contained wishlist — no login, no app, localStorage only.
   Public API on window.LogxWishlist. Storage key: log2x_wishlist
   Item shape: { handle, title, image, price, url, variantId } */
(function () {
  'use strict';
  var KEY = 'log2x_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
  }
  function has(handle) {
    return read().some(function (it) { return it.handle === handle; });
  }
  function count() { return read().length; }

  function normalize(item) {
    return {
      handle: item.handle, title: item.title || '', image: item.image || '',
      price: item.price || '', url: item.url || ('/products/' + item.handle),
      variantId: item.variantId || ''
    };
  }

  // add if absent (no-op if already saved). Returns true if it is now saved.
  function addItem(item) {
    if (!item || !item.handle) return false;
    var items = read();
    if (items.some(function (it) { return it.handle === item.handle; })) return true;
    items.push(normalize(item));
    write(items);
    // 本人指示2026-09-14(GM1): 追加時に統合ドロワー(ウィッシュタブ)を開き、トーストを出す
    try { document.dispatchEvent(new CustomEvent('fx-wishlist:added', { detail: { title: item.title || '', handle: item.handle } })); } catch (e) {}
    return true;
  }

  // add if absent / remove if present. Returns new saved-state (true=saved).
  function toggle(item) {
    if (!item || !item.handle) return false;
    var items = read();
    var i = items.findIndex(function (it) { return it.handle === item.handle; });
    if (i >= 0) { items.splice(i, 1); write(items); return false; }
    items.push(normalize(item));
    write(items);
    // 本人指示2026-09-14: ハート押下(toggleで追加)時も下から出る通知を出す=addItemと同じイベントを発火
    try { document.dispatchEvent(new CustomEvent('fx-wishlist:added', { detail: { title: item.title || '', handle: item.handle } })); } catch (e) {}
    return true;
  }
  function remove(handle) {
    write(read().filter(function (it) { return it.handle !== handle; }));
  }

  function updateBadge() {
    var n = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  // sync heart look (empty/filled) + aria-pressed for every button on the page
  function syncButtons() {
    document.querySelectorAll('.wishlist-button[data-handle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function drawer() { return document.getElementById('WishlistDrawer'); }
  function openDrawer() {
    var d = drawer(); if (!d) return;
    renderDrawer();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wishlist-drawer-open');
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wishlist-drawer-open');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderDrawer() {
    var list = document.getElementById('WishlistDrawerItems');
    if (list) {
      var items = read();
      if (!items.length) {
        list.innerHTML = '<li class="wishlist-drawer__empty">まだ保存した商品はありません。</li>';
      } else {
        list.innerHTML = items.map(function (it) {
          var img = it.image
            ? '<img class="wishlist-drawer__img" src="' + esc(it.image) + '" alt="" loading="lazy" width="70" height="88">'
            : '<span class="wishlist-drawer__img wishlist-drawer__img--empty"></span>';
          return '<li class="wishlist-drawer__item" data-handle="' + esc(it.handle) + '">' +
            '<a class="wishlist-drawer__link" href="' + esc(it.url) + '">' + img +
            '<span class="wishlist-drawer__meta"><span class="wishlist-drawer__title">' + esc(it.title) +
            '</span><span class="wishlist-drawer__price">' + esc(it.price) + '</span></span></a>' +
            '<button type="button" class="wishlist-drawer__remove" data-wishlist-remove="' + esc(it.handle) +
            '" aria-label="削除">&times;</button></li>';
        }).join('');
      }
    }
    syncFooter();
  }

  function syncFooter() {
    var addall = document.querySelector('[data-wishlist-addall]');
    if (addall) addall.disabled = count() === 0;
  }

  // Money for imported items only (save-time price comes pre-formatted from Liquid).
  // ponytail: JPY assumption — log2x is a single-currency (¥) store.
  function money(cents) {
    return '¥' + Math.round((cents || 0) / 100).toLocaleString('ja-JP');
  }

  function importFromUrl() {
    var wl;
    try { wl = new URLSearchParams(location.search).get('wl'); } catch (e) { return; }
    if (!wl) return;
    var have = read().map(function (it) { return it.handle; });
    var handles = wl.split(',').map(function (s) { return s.trim(); })
      .filter(function (h) { return h && have.indexOf(h) < 0; });
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
          addItem({
            handle: p.handle, title: p.title,
            image: p.featured_image || (p.media && p.media[0] && p.media[0].src) || '',
            price: money(p.price), url: '/products/' + p.handle, variantId: v && v.id
          });
        })
        .catch(function () {});
    })).then(function () { refresh(); if (drawer()) renderDrawer(); });
  }

  // ---- add all saved items to cart in one /cart/add.js request ----
  function addAll() {
    var items = read().filter(function (it) { return it.variantId; });
    if (!items.length) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(function (it) {
        return { id: Number(it.variantId), quantity: 1 };
      }) })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = '/cart';
    }).catch(function () {
      alert('カートに追加できませんでした。時間をおいて再度お試しください。');
    });
  }

  // ---- event delegation (works for dynamically added cards) ----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-button');
    if (btn) {
      e.preventDefault();
      toggle({
        handle: btn.getAttribute('data-handle'),
        title: btn.getAttribute('data-title'),
        image: btn.getAttribute('data-image'),
        price: btn.getAttribute('data-price'),
        url: btn.getAttribute('data-url'),
        variantId: btn.getAttribute('data-variant')
      });
      syncButtons(); updateBadge();
      if (drawer() && drawer().classList.contains('is-open')) renderDrawer();
      return;
    }
    if (e.target.closest('[data-wishlist-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-wishlist-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.closest('[data-wishlist-addall]')) { e.preventDefault(); addAll(); return; }
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) {
      e.preventDefault();
      remove(rm.getAttribute('data-wishlist-remove'));
      renderDrawer(); syncButtons(); updateBadge();
      return;
    }
    // Any click outside the sheet (other header buttons, cart open, blank area)
    // closes it. Overlay/Esc handled above/below; clicks inside the panel keep it open.
    var d = drawer();
    if (d && d.classList.contains('is-open') && !e.target.closest('.wishlist-drawer__panel')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function refresh() { syncButtons(); updateBadge(); syncFooter(); }
  document.addEventListener('DOMContentLoaded', function () { refresh(); importFromUrl(); });
  // re-sync after cart/section re-renders (Dawn dispatches these)
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('cart:refresh', refresh);
  // bfcache restore (back/forward) does NOT re-fire DOMContentLoaded — re-read the
  // count so the header badge reflects saves made on other pages this session.
  window.addEventListener('pageshow', refresh);
  if (document.readyState !== 'loading') { refresh(); importFromUrl(); }

  window.LogxWishlist = {
    read: read, has: has, count: count, toggle: toggle, add: addItem, remove: remove,
    syncButtons: syncButtons, updateBadge: updateBadge,
    renderDrawer: renderDrawer, openDrawer: openDrawer, closeDrawer: closeDrawer,
    addAll: addAll
  };
})();
